import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';

export interface PreSignedUrlRequest {
  fileName: string;
  contentType: string;
  organizationId: string;
}

export interface PreSignedUrlResponse {
  uploadUrl: string;
  key: string;
}

export interface PreSignedDownloadUrlResponse {
  downloadUrl: string;
}

export class ToolsDocumentsService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/documents`, client.getTimeout());
  }

  async postPreSignedUrl(request: {
    body: PreSignedUrlRequest;
    settings?: RetrySettings;
  }): Promise<PreSignedUrlResponse> {
    const response = await this.client.post<PreSignedUrlRequest, PreSignedUrlResponse>('/presigned-url', request.body, {
      bearerToken: await getAuthToken(),
      settings: request.settings,
    });
    return response.data;
  }

  async getPresignedDownloadUrl(request: {
    params: { key: string };
    settings?: RetrySettings;
  }): Promise<PreSignedDownloadUrlResponse> {
    const response = await this.client.get<PreSignedDownloadUrlResponse>('/presigned-url', request.params, {
      bearerToken: await getAuthToken(),
      settings: request.settings,
    });
    return response.data;
  }
}
